import {TagFiltered} from '@dv5/domain'
import React, {FC} from 'react'
import './TagsChooser.less'

interface ItemTagsChooserProps {
    tags: Array<TagFiltered>
    hasLabel: boolean
    disabled?: boolean
    setTags: (tags: Array<TagFiltered>) => void
}

export const TagsChooser: FC<ItemTagsChooserProps> = ({
                                                          tags,
                                                          hasLabel,
                                                          setTags,
                                                          disabled = false,
                                                      }) => {
    const handleTagToggle = (index: number) => {
        if (disabled) return
        const updatedTags = [...tags]
        updatedTags[index] = {
            ...updatedTags[index],
            checked: !updatedTags[index].checked
        }
        setTags(updatedTags)
    }

    return (
        <div className="item-tags-chooser">
            {hasLabel && <h3>Tags</h3>}
            <div className="item-tags-list">
                {tags.map((tagFiltered, index) => (
                    <div
                        key={tagFiltered.tag.id || index}
                        className={`item-tag ${tagFiltered.checked ? 'item-tag--checked' : ''}`}
                        role="checkbox"
                        aria-checked={tagFiltered.checked}
                        aria-disabled={disabled}
                        tabIndex={disabled ? -1 : 0}
                        onKeyDown={event => {
                            if (event.key === ' ' || event.key === 'Enter') {
                                event.preventDefault()
                                handleTagToggle(index)
                            }
                        }}
                        onClick={() => handleTagToggle(index)}
                    >
                        <div className="item-tag__checkbox">
                            {tagFiltered.checked ? '✓' : '○'}
                        </div>
                        <div className="item-tag__title">
                            {tagFiltered.tag.title}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
